/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetCommonState400Response,
  GetHelpRequest,
  GetHelpSite200Response,
  GetHelpSite401Response,
  GetHelpSite404Response,
  GetHelpSite422Response,
  GetHelpSiteRequest,
  Registration429Response,
} from '../models/index'
import {
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetHelpRequestFromJSON,
  GetHelpRequestToJSON,
  GetHelpSite200ResponseFromJSON,
  GetHelpSite200ResponseToJSON,
  GetHelpSite401ResponseFromJSON,
  GetHelpSite401ResponseToJSON,
  GetHelpSite404ResponseFromJSON,
  GetHelpSite404ResponseToJSON,
  GetHelpSite422ResponseFromJSON,
  GetHelpSite422ResponseToJSON,
  GetHelpSiteRequestFromJSON,
  GetHelpSiteRequestToJSON,
  Registration429ResponseFromJSON,
  Registration429ResponseToJSON,
} from '../models/index'

export interface GetHelpOperationRequest {
  getHelpRequest: GetHelpRequest
}

export interface GetHelpSiteOperationRequest {
  getHelpSiteRequest: GetHelpSiteRequest
}

/**
 * HelpApi - interface
 *
 * @export
 * @interface HelpApiInterface
 */
export interface HelpApiInterface {
  /**
   * Заявка с внешней формы (например, «получить помощь»): по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно: повторный запрос с тем же набором данных возвращает успех без повторной обработки (Redis-хеш, middleware form_request_idempotency); вместе с запросом принимаются UTM-метки (utm_capture). Публичный эндпоинт.
   * @summary Заявка с внешней формы
   * @param {GetHelpRequest} getHelpRequest Тип формы и данные; набор полей data определяется конфигурацией формы в БД (phone, email, name и др.)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpApiInterface
   */
  getHelpRaw(
    requestParameters: GetHelpOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHelpSite200Response>>

  /**
   * Заявка с внешней формы (например, «получить помощь»): по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно: повторный запрос с тем же набором данных возвращает успех без повторной обработки (Redis-хеш, middleware form_request_idempotency); вместе с запросом принимаются UTM-метки (utm_capture). Публичный эндпоинт.
   * Заявка с внешней формы
   */
  getHelp(
    requestParameters: GetHelpOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHelpSite200Response>

  /**
   * Заявка с внешней формы для сайта (например, «получить помощь»): контракт совпадает с /api/v1/get-help — по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно (middleware form_request_idempotency); UTM-метки принимаются вместе с запросом (utm_capture). Защищён site-verify, лимит 15 запросов в минуту. Публичный эндпоинт.
   * @summary Заявка с внешней формы (сайт)
   * @param {GetHelpSiteRequest} getHelpSiteRequest Тип формы и данные; набор полей data определяется конфигурацией формы в БД (phone, email, name и др.)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpApiInterface
   */
  getHelpSiteRaw(
    requestParameters: GetHelpSiteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHelpSite200Response>>

  /**
   * Заявка с внешней формы для сайта (например, «получить помощь»): контракт совпадает с /api/v1/get-help — по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно (middleware form_request_idempotency); UTM-метки принимаются вместе с запросом (utm_capture). Защищён site-verify, лимит 15 запросов в минуту. Публичный эндпоинт.
   * Заявка с внешней формы (сайт)
   */
  getHelpSite(
    requestParameters: GetHelpSiteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHelpSite200Response>
}

/**
 *
 */
export class HelpApi extends runtime.BaseAPI implements HelpApiInterface {
  /**
   * Заявка с внешней формы (например, «получить помощь»): по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно: повторный запрос с тем же набором данных возвращает успех без повторной обработки (Redis-хеш, middleware form_request_idempotency); вместе с запросом принимаются UTM-метки (utm_capture). Публичный эндпоинт.
   * Заявка с внешней формы
   */
  async getHelpRaw(
    requestParameters: GetHelpOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHelpSite200Response>> {
    if (requestParameters['getHelpRequest'] == null) {
      throw new runtime.RequiredError(
        'getHelpRequest',
        'Required parameter "getHelpRequest" was null or undefined when calling getHelp().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/get-help`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: GetHelpRequestToJSON(requestParameters['getHelpRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetHelpSite200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Заявка с внешней формы (например, «получить помощь»): по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно: повторный запрос с тем же набором данных возвращает успех без повторной обработки (Redis-хеш, middleware form_request_idempotency); вместе с запросом принимаются UTM-метки (utm_capture). Публичный эндпоинт.
   * Заявка с внешней формы
   */
  async getHelp(
    requestParameters: GetHelpOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHelpSite200Response> {
    const response = await this.getHelpRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Заявка с внешней формы для сайта (например, «получить помощь»): контракт совпадает с /api/v1/get-help — по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно (middleware form_request_idempotency); UTM-метки принимаются вместе с запросом (utm_capture). Защищён site-verify, лимит 15 запросов в минуту. Публичный эндпоинт.
   * Заявка с внешней формы (сайт)
   */
  async getHelpSiteRaw(
    requestParameters: GetHelpSiteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHelpSite200Response>> {
    if (requestParameters['getHelpSiteRequest'] == null) {
      throw new runtime.RequiredError(
        'getHelpSiteRequest',
        'Required parameter "getHelpSiteRequest" was null or undefined when calling getHelpSite().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/site/help-request`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: GetHelpSiteRequestToJSON(requestParameters['getHelpSiteRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetHelpSite200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Заявка с внешней формы для сайта (например, «получить помощь»): контракт совпадает с /api/v1/get-help — по типу находится конфигурация формы, данные валидируются по её полям и передаются в сервис (сохранение + уведомления AmoCRM). Идемпотентно (middleware form_request_idempotency); UTM-метки принимаются вместе с запросом (utm_capture). Защищён site-verify, лимит 15 запросов в минуту. Публичный эндпоинт.
   * Заявка с внешней формы (сайт)
   */
  async getHelpSite(
    requestParameters: GetHelpSiteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHelpSite200Response> {
    const response = await this.getHelpSiteRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
